import React from 'react';

import { Box, Chip, Paper, Stack, Typography } from '@mui/material';

import MarkdownPreview from '~/components/Common/MarkdownPreview';

import { parseReviewContent } from './parseChatReviewContent';

export default function ChatReviewContent({ content }: { content: string }) {
  return (
    <Stack
      spacing={1.5}
      sx={{
        typography: 'body2',
        overflowWrap: 'anywhere',
        '& p': { my: 1 },
        '& pre': { whiteSpace: 'pre-wrap' },
        '& img': { maxWidth: '100%' },
      }}
    >
      {parseReviewContent(content).map((part, index) => {
        if (part.type === 'raw') {
          return (
            <Typography key={index} component="pre" variant="inherit" sx={{ whiteSpace: 'pre-wrap' }}>
              {part.content}
            </Typography>
          );
        }
        if (part.type === 'text') {
          return (
            <MarkdownPreview
              key={index}
              content={part.content.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}
            />
          );
        }
        return (
          <Box key={index}>
            <Stack direction={part.type === 'pills_list' ? 'row' : 'column'} flexWrap="wrap" gap={1}>
              {part.options.map((option, optionIndex) =>
                part.type === 'pills_list' ? (
                  <Chip
                    key={optionIndex}
                    label={option.label}
                    variant="outlined"
                    sx={{ fontSize: 'inherit', height: 'auto', '& .MuiChip-label': { whiteSpace: 'normal', py: 1 } }}
                  />
                ) : (
                  <Paper key={optionIndex} variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="subtitle2">
                      {option.emoji} {option.title}
                    </Typography>
                    {option.description && (
                      <Typography variant="body2" color="text.secondary">
                        {option.description}
                      </Typography>
                    )}
                  </Paper>
                ),
              )}
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
